import styled, { css } from 'styled-components';

const BottomControls = styled.div`
  display: block;
  width: 100% !important;
  padding: 20px 30px 20px 30px;
  vertical-align: middle;

  ${props =>
    props.level &&
    css`
      padding-left: ${30 + 40 * props.level}px;
    `}

  @media (max-width: 900px) {
    ${props =>
      props.level &&
      css`
        padding-left: ${11 + 10 * props.level}px;
      `}
  }

  > svg {
    vertical-align: middle !important;
  }
`;

export default BottomControls;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/BottomControls/bottom-controls.jsx